import React, { Component, Fragment } from 'react'
import { pxToRem, color } from '../../utils'
import styled from 'styled-components'
import closeIcon from '../../assets/icons/close.svg'


const Header = styled.header`
  font-family: 'Open Sans', sans-serif;
  font-size: ${pxToRem(21)};
  text-align: left;
  color: ${color.secondary};
  margin: 0;
  padding: ${pxToRem(16)};
  border-bottom: 1px solid #d8d8d8;
  display: flex;

  @media only screen and (max-width: 700px) {
    font-size: ${pxToRem('20px')};
  }
`
const Title = styled.div`
  flex: 1;
  ${({ error }) =>
    error
      ? `
    color: ${color.danger};
  `
      : ''};
`

const SafeContent = styled.div`
  padding: ${pxToRem('20px')};
`

const CloseButton = styled.button`
  width: ${pxToRem('20px')};
  margin: 0;

  background: none;
  border: none;
  outline: none;
  padding: 0;
  padding-top: 2px;
  box-sizing: content-box;
  cursor: pointer;
  img {
    max-width: 100%;
  }
`

class ModalContent extends Component {
  renderContent = () => {
  const { children, title, closeMethod, safeContent = true } = this.props

    return (
      <Fragment>
        <Header>
          <Title id={`modal-title-${title}`}>{title}</Title>{' '}
          <CloseButton onClick={closeMethod} aria-label={'Fechar'}>
            <img aria-hidden={true} alt="close icon" src={closeIcon} />
          </CloseButton>
        </Header>
        {safeContent ? <SafeContent>{children}</SafeContent> : children}
      </Fragment>
    )
  }

  componentDidMount() {
    const { onEntered } = this.props
    
    onEntered && onEntered()
  }

  render() {
    return ( 
      this.renderContent()
    )
  } 
}

export default ModalContent


// WEBPACK FOOTER //
// ./src/components/Modal/ModalContent.js